import createCollectionRouteHandler from './CollectionsRouteHandler';

export default ({ collectionsConfig }) =>
  collectionsConfig.links.collections.map(collection => ({
    exact: true,
    name: 'collectionsScreen',
    path: collection.link.link.href,
    component: createCollectionRouteHandler({ collectionKey: collection.key }),
  }));
